export enum ComponentStatus {
  Unknown,
  Loading,
  Processing,
  Displaying,
  Warning,
  Error
}
